<template>
	<div
			class="card m-2 p-3 vendor-card"
			:class="{ 'border-dark': isSelected }"
			style="cursor: pointer;"
			@click="handleClick"
	>
		<div class="row no-gutters">
			<div class="col-md-4">
				<div class="d-flex align-items-center mb-1">
          <span
							class="status-dot mr-2"
							:class="vendor.isActive ? 'bg-success' : 'bg-danger'"
					></span>
					<h5 class="mb-0 mr-2 text-truncate" style="font-size: 14px;">{{ vendor.name }}</h5>
					<span v-if="country" class="badge badge-dark badge-pill mr-1">{{ country.countryIso }}</span>
					<span class="badge badge-light badge-pill mr-1">LF-Nr. {{ vendor.skuPrefix }}</span>
				</div>
				<div class="d-flex flex-wrap mt-2">
					<span class="badge badge-light badge-pill border mr-1">LK {{ vendor.deliveryClass }}</span>
					<span class="badge badge-pill border mr-1" :class="vendor.hasVirtualStocks ? 'badge-danger' : 'badge-success'">Stock: {{ vendor.hasVirtualStocks ? 'Virtual' : 'Real' }}</span>
					<span class="badge badge-pill border mr-1" :class="vendor.deliveryNoteActive ? 'badge-success' : 'badge-danger'">LS: {{ vendor.deliveryNoteActive ? 'Ja' : 'Nein' }}</span>
					<span class="badge badge-pill border mr-1" :class="vendor.hasVirtualStocks ? 'badge-danger' : 'badge-success'">BO: {{ vendor.hasVirtualStocks ? 'Ja' : 'Nein' }}</span>
				</div>
			</div>
			<div class="col-md-4 small text-muted">
				<div><strong>Versandintervall:</strong> {{vendor.shippingInterval}}</div>
				<div><strong>Versanddienstleister:</strong> {{ vendor.shippingCarrier }}</div>
			</div>

			<div class="col-md-4 small text-right text-muted">
				<div><strong>Account: </strong>{{ getFirstContact(vendor.procurementContact)?.name  ?? "-"}}</div>
				<div> {{ formatContactLine(vendor.procurementContact) }}</div>
				<div><strong>Retoure: </strong>{{ getFirstContact(vendor.returnsContact)?.email ?? "-"}}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "VendorListItem",
	props: ['vendor', 'country', 'shippingService', 'isSelected', 'disabled'],
	methods: {
		handleClick() {
			if (!this.disabled){
				this.$emit('click');
			} else {
				this.$bvToast.toast("Während der Bearbeitung kann der Händler nicht gewechselt werden.", {
					autoHideDelay: 3000,
					appendToast: false,
					variant: "danger",
				});
			}
		},
		getFirstContact(contact) {
			if (Array.isArray(contact)) {
				return contact[0] ?? null;
			}

			return contact ?? null;
		},
		formatContactLine(contact) {
			const firstContact = this.getFirstContact(contact);

			const parts = [
				firstContact?.email,
				firstContact?.phone,
			].filter(Boolean);

			return parts.length ? parts.join(' · ') : '-';
		},
	}
}
</script>

<style scoped>
.status-dot {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	display: inline-block;
}
.vendor-card:hover {
	box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}
</style>